import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'

// Mirrors the (01)–(04) markers already used inside each section.
const SECTIONS = [
  { id: 'about', num: '01', label: 'About' },
  { id: 'work', num: '02', label: 'Work' },
  { id: 'writing', num: '03', label: 'Writing' },
  { id: 'contact', num: '04', label: 'Contact' },
]

// Fixed rail that marks which section you're in. Homepage only — that's the
// only route where all four sections are on the page at once.
export const SectionRail = () => {
  const { pathname } = useLocation()
  const [active, setActive] = useState('')
  const onHome = pathname === '/'

  useEffect(() => {
    if (!onHome) return undefined
    let frame = 0

    const recalc = () => {
      frame = 0
      const mid = window.innerHeight / 2
      let best = ''
      let bestDist = Infinity
      SECTIONS.forEach((s) => {
        const el = document.getElementById(s.id)
        if (!el) return
        const r = el.getBoundingClientRect()
        const dist = Math.abs(r.top + r.height / 2 - mid)
        if (dist < bestDist) {
          bestDist = dist
          best = s.id
        }
      })
      setActive(best)
    }

    const onScroll = () => {
      if (!frame) frame = requestAnimationFrame(recalc)
    }

    recalc()
    window.addEventListener('scroll', onScroll, { passive: true })
    window.addEventListener('resize', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll)
      window.removeEventListener('resize', onScroll)
      if (frame) cancelAnimationFrame(frame)
    }
  }, [onHome])

  if (!onHome) return null

  return (
    <nav
      aria-label="Sections"
      className=" fixed right-6 top-1/2 z-40 hidden -translate-y-1/2 lg:block"
    >
      <ul className=" flex flex-col gap-5">
        {SECTIONS.map((s) => {
          const on = active === s.id
          return (
            <li key={s.id}>
              <a href={`#${s.id}`} className=" group flex items-center justify-end gap-3">
                <span
                  className={` font-mono text-[10px] uppercase tracking-[0.2em] transition-opacity duration-300 ${
                    on
                      ? 'text-mint-deep opacity-100'
                      : 'text-ink opacity-0 group-hover:opacity-60'
                  }`}
                >
                  {s.num} — {s.label}
                </span>
                <span
                  className={` h-px transition-all duration-300 ${
                    on ? 'w-9 bg-mint-deep' : 'w-4 bg-ink/25 group-hover:w-7'
                  }`}
                />
              </a>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}
